module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePage_EN_Euro_Mobile.4dae7d71.webp";